import { APIClient } from '@/services'
import { CommunityFeed } from '@/types'
import { communityAnalytics } from '@/utils'
import { memo, useCallback } from 'react'
import { ActionButton } from '../../atoms/ActionButton'
import { ReportModal } from '../../organisms/Report'
import { maybeOpenRegistrationWall } from '@/features/Auth/session/registrationWall'

const UnMemoizedReport = ({ item }: { item: CommunityFeed }) => {
  const profile = APIClient.Session.useProfile({ enabled: false })

  const handleReport = useCallback(async () => {
    const authorized = maybeOpenRegistrationWall()

    if (!authorized) return

    ReportModal.open({ content: { feed_item: item.id } })

    communityAnalytics.feedActionEvent('feed_report', item)
  }, [])

  const isMyPost = item?.profile?.id === profile?.data?.id

  const hasVideo = !!item.post?.video?.url

  if (!hasVideo || isMyPost || !item?.reportable) return null

  return <ActionButton icon="report" text={'Report'} onPress={handleReport} />
}

export const Report = memo(UnMemoizedReport)
